import { REPLY_TYPE } from '@/utils/responseHandler';
import { IntentSource, ALL_BOT_TYPE } from '@/utils/constants';
import getHqUIOptimisationGroup, { HQ_UI_OPTIMISATION_GROUP } from '@/utils/experiment/getHqUIOptimisation';
import firstInitStore from '@/stores/firstInit';
import { isDriverAndFoodUIOptimisation } from '@/utils/experiment/getDriverAndFoodUIOptimisationExperiment';
import { isDriverOrFood } from '@/config/core';

export const useUIOptimisationHotQuestion = (dialogue: any, res: any) => {
  if (isDriverOrFood()) {
    if (dialogue?.reply_type === REPLY_TYPE.FOOD_ORDER_CARD_WITH_BUTTON && isDriverAndFoodUIOptimisation()) {
      return true;
    }
  }

  if ((firstInitStore?.initStore?.botType !== ALL_BOT_TYPE.INTENT_BASE_BOT) && (res?.bot_type !== ALL_BOT_TYPE.INTENT_BASE_BOT)) { // 不是 buyer 的就不使用
    return false;
  }

  if (getHqUIOptimisationGroup() !== HQ_UI_OPTIMISATION_GROUP.CONTROL) {
    // 点击 category 后出 intent 的场景
    if (dialogue?.reply_type === REPLY_TYPE.NEW_HOT_QUESTION && isUIOptimisationHotQuestion(dialogue?.message_extra?.cat_intent_list?.source)) {
      return true;
    }
    // 点击 订单后的 场景
    if (dialogue?.reply_type === REPLY_TYPE.HOTQUESTION_WITH_MORE_ORDER) {
      return true;
    }
    // shipping page    order detail page
    if (dialogue?.reply_type === REPLY_TYPE.ORDER_HOTQUESTIONS) {
      return true;
    }
    //  rr 的场景
    if (dialogue?.reply_type === REPLY_TYPE.RR_HOTQUESTIONS) {
      return true;
    }
    //  order shortcut  order list 的场景
    if (dialogue?.reply_type === REPLY_TYPE.ORDER_LIST) {
      return true;
    }
  }
  return false;
};

export const isUIOptimisationHotQuestion = (source?: number) => {
  return source === IntentSource.Category;
};
